<template>
  <suspense>
    <component v-if="contentfulComponent" :is="contentfulComponent" v-bind="{ fields: data, sys: system }" />
  </suspense>
</template>

<script>
import { useContentful, contentfulProps } from '@/compositions/useContentful.js';
import { getComponent } from '@/services/ContentfulService.js';
import { computed } from 'vue';

export default {
  props: contentfulProps,
  async setup(p, c) {
    const { data, system, init } = useContentful('$dynamic_renderer', p, c);
    await init();
    const contentfulComponent = computed(() => getComponent(system?.value?.contentType?.sys?.id));
    return { data, system, contentfulComponent };
  },
};
</script>
